import type { User } from "instantdb/types";

/**
 * Check if user has pro
 * If user has proStatus "canceled" and nextBillingDate is in the future, return true
 * If user has proStatus "active", return true
 * Otherwise, return false
 */
export const userHasPro = (user: User) => {
  if (user?.proStatus === "canceled" && user?.nextBillingDate) {
    try {
      const nextBillingDate = new Date(user.nextBillingDate);
      // Use UTC dates to avoid timezone issues
      const today = new Date();
      return nextBillingDate.setHours(0, 0, 0, 0) > today.setHours(0, 0, 0, 0);
    } catch (e) {
      console.error("Invalid nextBillingDate:", user.nextBillingDate);
      return false;
    }
  }
  return user?.proStatus === "active";
};
